import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { format, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import { Chart, DATE_FORMAT, Runtime } from 'helper/products/synopticCharts';
import {
  selectChart,
  selectDate,
  selectRuntime,
} from 'redux/reducers/synopticChartsReducer';
import CampoSection from './CampoSection';
import DateSection from './DateSection';
import RuntimeSection from './RuntimeSection';

import './index.scss';

type PanelSection = 'campo' | 'data' | 'runtime' | '';

export default function ControlPanelSheet({
  open,
  dismiss,
}: {
  open: boolean;
  dismiss: () => void;
}) {
  const [openSection, setOpenSection] = useState<PanelSection>('campo');
  const toggleSection = (section: PanelSection) => () => (
    setOpenSection((current) => (current === section ? '' : section))
  );

  const chart: Chart | undefined = useSelector(selectChart);
  const date: string | undefined = useSelector(selectDate);
  const runtime: Runtime | undefined = useSelector(selectRuntime);

  const dateLabel = date
    ? format(parse(date, DATE_FORMAT, new Date()), "dd 'de' MMM", { locale: ptBR })
    : undefined;

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Painel de controle"
      className="sc-mobile-panel"
    >
      <div className="sc-mobile-panel-body">
        <Section
          label="Campo sinótico"
          valueText={chart?.campo}
          open={openSection === 'campo'}
          onToggle={toggleSection('campo')}
        >
          <CampoSection onSelect={() => setOpenSection('')} />
        </Section>

        <Section
          label="Data de previsão"
          valueText={dateLabel}
          open={openSection === 'data'}
          onToggle={toggleSection('data')}
        >
          <DateSection />
        </Section>

        <Section
          label="Runtime"
          valueText={runtime?.label}
          open={openSection === 'runtime'}
          onToggle={toggleSection('runtime')}
        >
          <RuntimeSection />
        </Section>
      </div>

      <div className="sc-mobile-panel-footer">
        <button type="button" className="sc-mobile-panel-confirm" onClick={dismiss}>
          Concluir
        </button>
      </div>
    </BottomSheet>
  );
}
